import * as React from 'react'
import { cn } from '@/lib/utils'

export interface PushButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode
}

export const PushButton = React.forwardRef<HTMLButtonElement, PushButtonProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <button ref={ref} className={cn('pushable group', className)} {...props}>
        <span className="shadow" />
        <span className="edge" />
        <span className="front font-sans group-hover:-translate-y-1.5 group-active:-translate-y-0.5">
          {children}
        </span>
      </button>
    )
  }
)
PushButton.displayName = 'PushButton'
